import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as action from "../pagoDeducibleAuto-actions";
import "../pago-deducible.css";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import visa from "../../img/visa-card.png";
import amex from "../../img/amex-card.png";
import masterCard from "../../img/mastercard-card.png";
import genCard from "../../img/creditCardG.png";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import {errorCampoRequerido, errorMultiple,formatFchExpire} from "../utils";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import {nombreBancoBin, handleChanges, handlePattern,
	handleKeys, hanldeChangeTarjet,
	erroresPago,mascaraViMaGen, mascaraAmex,
	verifyAmex,errorGenCard,errorElseBlur, errorFchVencimiento
} from "./utils";

const useStyles = makeStyles((theme) => ({
	wTextfieldL: {
		width: "100%",
		fontSize: "16px",
		color: "#33445F",
	},
	iconCard: {
		width: "24px",
		height: "24px",
		marginBottom: "5px",
		color: "#647085",
	},
	labelCheckbox: {
		marginBottom: "0px",
		marginRight: "0px",
		marginTop:"50px",
		marginLeft:"5px",
		"& .MuiSvgIcon-root":{
			width:"18px",
			height:"18px"
		},"& .MuiIconButton-root": {
			marginRight: "20px"
		}
	}
}));

const gridTipoTarjet = (classes,tipoTarjetaPago,handleTipoTarjetaPago) => {
	return <Grid container className={classes.pRight} item xs={12} sm={12} md={6} lg={6}>
		<FormControl component="fieldset" style={{width:"100%"}}>
			<p className="tipoTarjeta">Tipo de tarjeta</p>
			<RadioGroup
				className="columnDirection"
				aria-label="gender"
				name="gender1"
				value={tipoTarjetaPago}
				onChange={handleTipoTarjetaPago}
			>
				<Grid item xs={6} sm={6} md={6} lg={6}>
					<FormControlLabel
						value="28"
						control={<Radio />}
						label="Débito"
					/>
				</Grid>
				<Grid  item xs={6} sm={6} md={6} lg={6}>
					<FormControlLabel
						value="04"
						control={<Radio />}
						label="Crédito"
					/>
				</Grid>
			</RadioGroup>
		</FormControl>
	</Grid>;
};

const inputBanco = (errorForm,blurInput,classes,handleChange,banco) => {
	return  <Grid style={{width: "100%"}} item xs={12} sm={12} md={6} lg={6}>
		<TextField
			error={errorForm.banco}
			helperText={errorCampoRequerido(errorForm.banco)}
			onBlur={blurInput}
			type="text"
			value={banco}
			className={classes.wTextfieldL}
			id="banco"
			label="Banco"
			name="banco"
			onChange={handleChange}
		/>
	</Grid>;
};

const inputNombreTitular = (blurInput,errorForm,classes,creditCardPago,handleChange) => {
	return   <Grid style={{width: "100%"}} item xs={12} sm={12} md={6} lg={6}>
		<TextField
			onBlur={blurInput}
			error={errorForm.nombreTitular}
			type="text"
			className={classes.wTextfieldL}
			id="nombreTitular"
			label="Nombre del titular"
			value={creditCardPago.nombreTitular}
			onChange={handleChange}
			name="nombreTitular"
			helperText={errorCampoRequerido(errorForm.nombreTitular)}
		/>
	</Grid>;
};

const checkAcuerdo = (classes,creditCardPago,handleChange) => {
	return <FormControlLabel
		className={classes.labelCheckbox}
		control={
			<Checkbox
				checked={creditCardPago.aceptarCargo}
				onChange={handleChange}
				name="aceptarCargo"
				id="aceptarCargo"
				className="checBoxAcepto"
			/>
		}
		label="Acepto el cargo y estoy de acuerdo con el monto a pagar"
	/>;
};

const clickInput = (event) => {
	if(event.target.value){
		var myElement = document.getElementById(event.target.name);
		myElement.selectionStart = event.target.value.length;
		myElement.selectionEnd = event.target.value.length;
	}
};

const PagoEnLinea = (props) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const global = useSelector((state) => state.global);
	const [creditCardPago, setCreditCardPago] = useState({
		nombreTitular: "",
		numeroTarjeta: "",
		maskNumeroTarjeta: "",
		banco: "",
		fchVencimiento: "",
		aceptarCargo: false,
		codigoCvv: "",
	});
	const [errorForm, setForm] = useState({
		nombreTitular: false,
		numeroTarjeta: false,
		banco: false,
		fchVencimiento: false,
		invalidFchVencimiento: false,
		invalidCard: false,
	});
	const [tarjetaTemp,setTarjetaTemp] = useState("");
	const [anoActual, setAnoActual] = useState(0);
	const [mesActual, setMesActual] = useState(0);
	const [tipoTarjeta, setTipoTarjeta] = useState(visa);
	const [sizeCvv,setSizeCvv] = useState(3);
	const [typeNumCard, setTypeNumCard] = useState("");
	const [longCard, setLongCard] = useState(19);
	const [banco, setBanco] = useState("");
	const [cvvTemp, setCvvTemp] = useState("");
	const [maskAmex, setMaskAmex] = useState(false);
	const [invalidChar, setInvalidChar] = useState(false);
	const [tipoTarjetaPago,setTipoTarjetaPago] = useState("04");
	useEffect(() => {
		const fecha = new Date();
		const ano = fecha.getFullYear();
		const mes = fecha.getMonth();
		setAnoActual(ano);
		setMesActual(mes);
	}, [props]);

	const handleChange = (event) => {
		handlePattern(event, typeNumCard);
		handleChanges(event,creditCardPago,errorForm,
			cvvTemp,{formatFchExpire,setCreditCardPago,
				setForm,setCvvTemp,setBanco});
		if(event.target.type === "checkbox" ){
			props.dataPagoLinea({
				creditCardPago,tarjetaTemp,tipoTarjeta,sizeCvv,typeNumCard,longCard,banco,
				tipoTarjetaPago,maskAmex,aceptarCargo: event.target.checked,errorForm
			});
			dispatch(action.setDisabledButtonPago("terminosCondiciones",event.target.checked));
		}else{
			props.dataPagoLinea({
				creditCardPago,tarjetaTemp,tipoTarjeta,sizeCvv,typeNumCard,longCard,banco,
				tipoTarjetaPago,maskAmex, aceptarCargo: creditCardPago.aceptarCargo,errorForm
			});

		}
	};

	const maskTarjetAmex = (event) => {
		mascaraAmex(event,{typeNumCard,tarjetaTemp,amex,visa},
			action,global.tid,creditCardPago,errorForm,
			{setTipoTarjeta,setTypeNumCard,setSizeCvv,
				setLongCard,handlePattern,setMaskAmex,setTarjetaTemp,setCreditCardPago,
				setBanco,setForm,dispatch,verifyAmex,nombreBancoBin});
	};

	const maskViMaGen = (event) => {
		mascaraViMaGen(event,global.tid,errorForm,action,creditCardPago,
			{typeNumCard,tarjetaTemp,masterCard,visa,genCard},{handlePattern,setCreditCardPago,setTarjetaTemp,
				setTipoTarjeta,setSizeCvv,setTypeNumCard,setLongCard,
				setMaskAmex,nombreBancoBin,dispatch,setBanco,setForm,});
	};

	const blurInput = (event) => {
		if (creditCardPago[event.target.name] !== "") {
			setForm({
				...errorForm,
				[event.target.name]: false,
			});
			if(event.target.name === "nombreTitular"){
				dispatch(action.setDisabledButtonPago("inpNombreTitular",true));
			}
			erroresPago(event,{typeNumCard,sizeCvv,longCard,anoActual,mesActual},creditCardPago,
				errorForm,action,{errorGenCard,setForm,errorFchVencimiento,dispatch});
		}else if(event.target.name === "banco" && event.target.value !== ""){
			setForm({
				...errorForm,
				[event.target.name]: false,
			});
			dispatch(action.setDisabledButtonPago("inpBanco",true));
		}else{
			errorElseBlur(event,setForm,errorForm,dispatch,action);
		}
		props.dataPagoLinea({
			creditCardPago,tarjetaTemp,tipoTarjeta,sizeCvv,typeNumCard,longCard,banco,
			tipoTarjetaPago,maskAmex,aceptarCargo: creditCardPago.aceptarCargo,errorForm
		});
	};

	const handleKey = (e) => {
		handleKeys(e, setInvalidChar);
	};
	const handleTipoTarjetaPago = (event) => {
		setTipoTarjetaPago(event.target.value);
		props.dataPagoLinea({
			creditCardPago,tarjetaTemp,tipoTarjeta,sizeCvv,typeNumCard,longCard,banco,
			tipoTarjetaPago,maskAmex,aceptarCargo: creditCardPago.aceptarCargo,errorForm
		});
	};

	return(
		<div>
			<p className="pTitle">Pago en línea</p>
			<p className="pSolicitud">
                Captura los siguientes datos de tu tarjeta para proceder con
                el pago correspondiente.
			</p>
			<Grid container spacing={3} flexgrow={1} className={classes.inputStyles}>
				{inputNombreTitular(blurInput,errorForm,classes,creditCardPago,handleChange)}
				<Grid style={{width: "100%"}} item xs={12} sm={12} md={6} lg={6}>
					<TextField
						onFocus={clickInput}
						onClick={clickInput}
						autoComplete="off"
						style={{ width: "100%"}}
						onBlur={blurInput}
						className="numeroTarjeta"
						type="text"
						id="numeroTarjeta"
						name="numeroTarjeta"
						onKeyDown={handleKey}
						onChange={(e) => hanldeChangeTarjet(e,{handlePattern,maskViMaGen,maskTarjetAmex},
							typeNumCard,maskAmex,invalidChar)}
						value={creditCardPago.numeroTarjeta}
						onPaste={(e)=>{
							e.preventDefault();
							return false;
						}} 
						onCopy={(e)=>{
							e.preventDefault();
							return false;
						}}
						helperText={errorMultiple("numeroTarjeta",errorForm.numeroTarjeta,errorForm.invalidCard)}
						error={errorForm.numeroTarjeta || errorForm.invalidCard}
						label="Número de tarjeta"
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<CreditCardIcon
										className={classes.iconCard}
									></CreditCardIcon>
								</InputAdornment>
							),
						}}
					/>
				</Grid>
			</Grid>
			<Grid container spacing={3} flexgrow={1} >
				{gridTipoTarjet(classes,tipoTarjetaPago,handleTipoTarjetaPago)}
				{inputBanco(errorForm,blurInput,classes,handleChange,banco)}
			</Grid>
			<Grid container spacing={3} className={classes.secondGrid}>
				<Grid style={{width: "100%"}} item xs={12} sm={12} md={6}lg={6}>
					<TextField
						onFocus={clickInput}
						onClick={clickInput}
						onPaste={(e)=>{
							e.preventDefault();
							return false;
						}} 
						onCopy={(e)=>{
							e.preventDefault();
							return false;
						}}
						autoComplete="off"
						style={{ width: "100%" }}
						onBlur={blurInput}
						className="fchVencimiento"
						type="text"
						id="fchVencimiento"
						name="fchVencimiento"
						onChange={handleChange}
						value={creditCardPago.fchVencimiento}
						helperText={errorMultiple("fchVencimiento",errorForm.fchVencimiento,errorForm.invalidFchVencimiento)}
						error={errorForm.fchVencimiento || errorForm.invalidFchVencimiento}
						label="Fecha de vencimiento (MM / AA)"
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<CalendarTodayOutlinedIcon
										className={classes.iconCard}
									></CalendarTodayOutlinedIcon>
								</InputAdornment>
							),
						}}
					/>
				</Grid>
			</Grid>
			{checkAcuerdo(classes,creditCardPago,handleChange)}
		</div>
	);
};
export default PagoEnLinea;


// WEBPACK FOOTER //
// ./src/pago-deducible-auto/pago/pagoLinea.cmpt.js